// extracted by mini-css-extract-plugin
export default {"form":"SearchBar_form__ngDTv"};